import { Card, Col, Row, Badge, Pagination } from "antd";
import AssignmentReviewByNotify from "components/AssignmentReviewByNotify";
import { filter, find, get, map, sortBy } from 'lodash';
import React, { Suspense, useEffect, useMemo, useState } from "react";

const Lottie = React.lazy(() => import('lottie-react'));
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useAllBook } from "store/books/selectors";
import { useBookUnits } from "store/booksUnits/selectors";
import { useClassActivities } from "store/classActivities/selectors";
import { handleListClassActivities } from "store/classActivities/thunks";
import { useClassQuizzes } from "store/classQuizzes/selectors";
import { handleListClassQuizzes } from "store/classQuizzes/thunks";
import { useCurrentClass } from "store/classes/selectors";
import { handleGamePopupNotify } from "store/notification/thunks";
import { useResources } from "store/resources/selectors";
import { handleListClassSubmissions } from "store/submissions/thunks";
import { useCurrentUser } from "store/users/selectors";
import styled from "styled-components";
import { NOTIFICATIONICONS } from "utils/assets/images/lootie";
import {
  imageFetch,
  imageFetchFromPodcast,
  isVideo
} from "utils/lib/ebookHelper";
import { collection, deleteDoc, doc, onSnapshot, orderBy, query, where } from "firebase/firestore";
import { useFirebase } from "containers/FirebaseContext";
import { useCollectionNotification } from "utils/methods/firebaseNotification";
import { useShareNotification } from "utils/methods/firebaseShareAssignment";
import { debatePoster, IGameHome7, SoyHistoriasNew } from "utils/assets/images";
import { useClassGameActivity } from "store/one_game/selectors";
import { Alert, Snackbar } from "@mui/material";
import { getCoverForAssignment } from "utils/methods/functions";
import SpinLoader from "components/Loader/SpinLoader";
import { handleListWorkSheet } from "store/worksheet/thunks";
import Loading from "components/Loading";
import { updateUI } from 'store/UI/actions';
import { handleListStoryAiConfig } from 'store/StoryAiCofig/thunks';
import usePopUpAtOnce from 'components/hooks/usePopUpAtOnce';
import SentryWrap from 'components/Sentry';
import { useExams } from "store/exams/selectors";
import { useUserClasses } from "store/userClasses/selectors";

const Container = styled.div`
  min-height: 50vh;
  width: 100%;
  padding: 30px 60px;
  @media (max-width: 600px) {
    padding: 20px 0px;
  }
`;
const NotificationSection = styled.div`
  padding-left: 10px;
  max-width: calc(100% - 60px);
`;
const TextTitle = styled.div`
  font-size: 16px;
  color: #000000;
  font-weight: 600;
  text-align: left;
  word-wrap: break-word;
`;
const TextDate = styled.div`
  font-size: 13px;
  color: #000000;
  font-weight: 500;
  text-align: left;
`;
const TextDateTitle = styled.div`
  font-size: 13px;
  color: #000000;
  font-weight: 600;
  text-align: left;
`;

const Image = styled.img`
  height: 70px;
  width: 54px;
`;

const NotificationsMainSection = styled.div`
  display: flex;
  flex-direction: row;
  align-item: center;
  padding-left: 20px;
`;
const BackButton = styled.button`
  background-color: transparent;
  border: none;
  color: #1c3173;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  margin-bottom: 10px;
  padding: 0;
`;

const NotificationTitle = styled.p`
  font-size: 22px;
  font-weight: 600;
`;
const ReadAllBtn = styled.button`
  background-color: white;
  border: none;
  outline: none;
  cursor: pointer;
  margin-bottom: 10px;
`;
const TextReadAll = styled.p`
  font-size: 15px;
  font-weight: 600;
  color: rgb(28, 49, 115);
  margin-bottom: 6px;
`;
const Notification = () => {
  const exams = useExams();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const bookUnits = useBookUnits();
  const resources = useResources();
  const booksAllList = useAllBook();
  const userClasses = useUserClasses();
  const { firestore, firebaseUser } = useFirebase();
  const currentUser = useCurrentUser();
  const currentClass = useCurrentClass();
  const [reviewData, setReviewData] = useState();
  const { updateShareNotification } = useShareNotification();
  const { updateCollectionNotification, deleteOldNotifications, markAllAsRead } = useCollectionNotification();
  const { updateShareNotificationsBatch } = useShareNotification();
  const classActivities = useClassActivities()
  const { class_game_activity } = useClassGameActivity();
  const classQuizzes = useClassQuizzes()
  const allAssignment = [...classActivities, ...classQuizzes, ...class_game_activity];
  const { updatePopUpAtOnce } = usePopUpAtOnce();
  const [isnotification, setIsnotification] = useState(false);
  const [loadingQuestions, setloadingQuestions] = useState(false);
  const [selectedNotification, setSelectedNotification] = useState();
  const [shareNotificationsData, setShareNotificationsData] = useState([])
  const [assignmentDrawer, toggleAssignmentDrawer] = useState(false);
  const [notificationsData, setNotificationsData] = useState([])
  const [markAllDoneNotificationLoading, setMarkAllDoneNotificationLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [openReviewDialog, setReviewDialog] = React.useState({
    open: false,
    message: '',
  });

  const isExamHidden = (chapter) => {
    const fetchExams = exams?.find((entry) => entry.exams.flatMap((exam) => `${exam.bookId}`).includes(`${chapter}`));
    if (!fetchExams) {
      return false;
    }
    const classInfo = find(userClasses, ['id', currentClass?.id]);
    const isHidden = classInfo?.config?.meta_data || {};
    const examLevel = fetchExams?.exam_school || '';
    if (isHidden.highSchool && examLevel === 'high') {
      return true;
    }
    if (isHidden.middleSchool && examLevel === 'middle') {
      return true;
    }
    return false;
  }
  const allNotificationsData = useMemo(() => {
    const combined = [...notificationsData, ...shareNotificationsData];
    const filtered = combined.filter((item) => {
      const timestamp = item.modified || item.shared_time;
      if (!timestamp) return false;
      const dateCheck = new Date(timestamp);
      return !isNaN(dateCheck.getTime());
    });
    return filtered.sort((a, b) => {
      const timestampA = a.modified || a.shared_time || 0;
      const timestampB = b.modified || b.shared_time || 0;
      const dateA = new Date(timestampA);
      const dateB = new Date(timestampB);
      const isValidA = !isNaN(dateA.getTime());
      const isValidB = !isNaN(dateB.getTime());
      
      if (!isValidA && !isValidB) {
        const aIsNew = a.userSeen ? !a.userSeen.includes(currentUser?.id) : !a.seen;
        const bIsNew = b.userSeen ? !b.userSeen.includes(currentUser?.id) : !b.seen;
        if (aIsNew && !bIsNew) return -1;
        if (!aIsNew && bIsNew) return 1;
        return (b.id || '').localeCompare(a.id || '');
      }
      if (!isValidA) return 1;
      if (!isValidB) return -1;
      
      const timeDiff = dateB - dateA;
      if (timeDiff === 0) {
        const aIsNew = a.userSeen ? !a.userSeen.includes(currentUser?.id) : !a.seen;
        const bIsNew = b.userSeen ? !b.userSeen.includes(currentUser?.id) : !b.seen;
        if (aIsNew && !bIsNew) return -1;
        if (!aIsNew && bIsNew) return 1;
        return (b.id || '').localeCompare(a.id || '');
      }
      return timeDiff;
    });
  }, [notificationsData, shareNotificationsData, currentUser?.id]);

  const pageSize = 50;
  const paginatedNotifications = useMemo(() => {
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    return allNotificationsData.slice(startIndex, endIndex);
  }, [allNotificationsData, currentPage]);

  // const findActivityData = useMemo(() => {
  //   return [...classActivities, ...classQuizzes, ...class_game_activity];
  // }, [classActivities, classQuizzes, class_game_activity])
  
  useEffect(() => {
    deleteOldNotifications();
  }, []);

  useEffect(() => {
    if (!firebaseUser) return;
    const unsubscribe = listenToNotificationData(get(currentClass, 'id', ''), currentUser.id);
    const unsubscribeShare = listenToShareNotificationData();
    return () => {
      if (unsubscribe && typeof unsubscribe === 'function') {
          unsubscribe();
      }
      if (unsubscribeShare && typeof unsubscribeShare === 'function') {
          unsubscribeShare();
      }
    };
  }, [currentClass, currentUser, firebaseUser])

  const listenToNotificationData = (classID, userId) => {
    if (!classID) {
      return () => { };
    }
    const collectionRef = collection(firestore, "notifications");
    const q = query(collectionRef,
      where("classId", "==", classID),
      where("receiversId", "array-contains", userId),
      where("senderId", "!=", currentUser.id),
      orderBy("modified", "desc")
    );
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const notifications = [];
      querySnapshot.forEach((doc) => {
        const data = doc.data();
        const originalId = data.id;
        notifications.push({ 
          ...data, 
          id: originalId || doc.id,
          firebaseDocId: doc.id
        });
      });
      setNotificationsData(notifications);
    }, (error) => {
      console.error("Error listening to session changes:", error);
    });
    return unsubscribe;
  };

  const filterNotificationData = useMemo(() => {
    const allNotifications = [...notificationsData, ...shareNotificationsData];
    return allNotifications.sort((a, b) => {
      const userSeenA = get(a, "userSeen", []);
      const userSeenB = get(b, "userSeen", []);
      const seenStatusA = userSeenA ? !userSeenA.includes(currentUser?.id) : get(a, "seen", false);
      const seenStatusB = userSeenB ? !userSeenB.includes(currentUser?.id) : get(b, "seen", false);
      
      if (seenStatusA !== seenStatusB) {
        return seenStatusB ? 1 : -1;
      }
      
      const dateA = new Date(get(a, "modified", ""));
      const dateB = new Date(get(b, "modified", ""));
      return dateB - dateA;
    });
  }, [notificationsData, shareNotificationsData, currentUser]);


  const listenToShareNotificationData = () => {
    if (!firestore || !currentUser?.id) {
        return () => { };
    }
    const collectionRef = collection(firestore, "share_notifications");
    const q = query(collectionRef,
        where("createdBy", "!=", currentUser.id),
        where("notification_list", "array-contains", currentUser.id)
    );
    const unsubscribe = onSnapshot(q, async (querySnapshot) => {
        const shareNotifications = [];
        const deletePromises = [];
        
        querySnapshot.forEach((docSnapshot) => {
            const data = docSnapshot.data();
            const sharedTime = data.shared_time || data.modified;
            
            if (sharedTime) {
                const dateCheck = new Date(sharedTime);
                const isDateValid = !isNaN(dateCheck.getTime());
                
                if (!isDateValid) {
                    const docRef = doc(firestore, "share_notifications", docSnapshot.id);
                    deletePromises.push(deleteDoc(docRef));
                    return;
                }
            } else {
                const docRef = doc(firestore, "share_notifications", docSnapshot.id);
                deletePromises.push(deleteDoc(docRef));
                return;
            }
            
            const userSeen = data.userSeen || [];
            const timestamp = sharedTime || new Date().toISOString();              
            const formattedNotification = {
                id: docSnapshot.id,
                displayName: data.displayName || data.display_name || 'Shared Content',
                message: data.message || '',
                modified: timestamp,
                shared_time: data.shared_time || timestamp,
                data: {
                    chapter: data.chapter || data.bookId,
                    page: data.page || data.pageId,
                    id: data.id,
                    assignmentType: data.data?.assignmentType || data.assignmentType || 'worksheet',
                    storyInstruction: data.data?.storyInstruction || data.storyInstruction || '',
                    url: data.url
                },
                type: 'share_notification',
                userSeen: userSeen,
                senderId: data.createdBy,
                receiversId: data.notification_list || [],
                shareNotificationData: data
            };
            shareNotifications.push(formattedNotification);
        });
        
        if (deletePromises.length > 0) {
            await Promise.all(deletePromises);
        }
        
        setShareNotificationsData(shareNotifications);
    }, (error) => {
        console.error("Error listening to share notifications:", error);
    });
    return unsubscribe;
  };

  const getEngageCoverImage = (assignmentData) => {
    if (!assignmentData) {
      return null;
    }
    const is_engage = assignmentData?.config_assignment?.isFrom === 'engagement';
    if (is_engage) {
      const sortById = sortBy(booksAllList, 'id');
      const book = find(sortById, { id: assignmentData?.chapter });
      if (book?.engage) {
        const engage = find(book.engage, { id: assignmentData?.config_assignment?.engage_id });
        if (engage?.imageData) {
          const findImageData = find(engage.imageData, { 
            id: assignmentData?.config_assignment?.sequence_order 
          });
          return findImageData?.resource;
        }
      }
    }
    return null;
  };

  const findEngageData = (assignmentData) => {
    try {
      if (!assignmentData) return null;
      const currentEngage = assignmentData?.config_assignment?.engage_id;
      if (currentEngage) {
        const sortById = sortBy(booksAllList, 'id');
        const book = find(sortById, { id: assignmentData?.chapter });
        if (book?.engage) {
          const engage = find(book.engage, { id: currentEngage });
          return engage;
        }
      }
      return null;
    } catch (error) {
      console.log(error, "error");
      return null;
    }
};

  const modalSrc = (activeAssignment, findData) => {
    if (activeAssignment?.type === 'share_notification') {
      const shareData = activeAssignment?.shareNotificationData || activeAssignment;
      const assignmentType = shareData?.data?.assignmentType || shareData?.assignmentType || '';
      const storyInstruction = shareData?.data?.storyInstruction || shareData?.storyInstruction || '';
      
      if (assignmentType === 'story') {
        return SoyHistoriasNew;
      }
      
      if (storyInstruction) {
        const storyData = {
          data: {
            storyInstruction: storyInstruction,
            assignmentType: 'story'
          }
        };
        const cover_img_ext = getCoverForAssignment(storyData);
        if (cover_img_ext) return cover_img_ext;
      }
    }
    
    let assignmentData = null;
    if (findData?.data?.config_assignment) {
      assignmentData = findData.data;
    } else if (activeAssignment?.data?.config_assignment) {
      assignmentData = activeAssignment.data;
    } else {
      assignmentData = findData?.data || activeAssignment?.data;
    }
    const engageCoverImage = getEngageCoverImage(assignmentData);
    if(engageCoverImage) return engageCoverImage;
    
    const item = activeAssignment?.data?.game_data || {};
    const type = activeAssignment?.data?.assignmentType || '';
    const cover_img_ext = getCoverForAssignment(findData)
    if(cover_img_ext) return cover_img_ext;
    const image_url = item && item?.media_urls?.image ? item?.media_urls?.image : IGameHome7
    if (type === "debate") return debatePoster;
    if (isVideo(get(activeAssignment, "data.chapter"), resources)) {
      return imageFetchFromPodcast(get(activeAssignment, "data.chapter"), resources);
    } else if (get(activeAssignment, "type") === 'play_game_notification') {
      return image_url;
    } else {
      return imageFetch(
        booksAllList,
        get(activeAssignment, "data.chapter"),
        get(activeAssignment, "data.page")
      );
    }
  };

  const gridStyle = {
    width: "100%",
    textAlign: "center",
    padding: "7px",
    cursor: "pointer",
  };
  const gridStyleSeen = {
    width: "100%",
    textAlign: "center",
    padding: "7px",
    cursor: "pointer",
    backgroundColor: "#e8e4ee"
  }

  const redirectToAssignmentVideo = (id) => {
    let url = `/video?id=${id}&quiz=1`
    navigate(url);
  }

  const onNotificationClick = (data) => {
    const chapter = get(data, "data.chapter", '')
    const assignmentId = get(data, "data.id", '')
    const assignmentPage = get(data, "data.page", 0)
    const type = get(data, 'type', '')
    const otherType = get(data, 'data.assignmentType', '')
    
    const assignmentData = data?.data;
    const isEngageAssignment = assignmentData?.config_assignment?.isFrom === 'engagement';
    let engageData = null;
    if (isEngageAssignment) {
      engageData = findEngageData(assignmentData);
    }

    const openEngageModal = () => {
      if (isEngageAssignment && engageData && engageData?.imageData?.length > 0) {
        setTimeout(() => {
          updatePopUpAtOnce(false);
          dispatch(updateUI({ 
            openEngageModalTeacher: { 
              open: true, 
              id: engageData?.id,
              engagePageId: engageData?.pageId,
              data: engageData?.imageData,
              engageName: engageData?.sequence
            } 
          }));
        }, 1000);
      }
    };
    
    if ((otherType === 'debate' || otherType === 'bingo' || otherType === 'game' || otherType === 'worksheet') && data?.type === "update_grade") {
      navigate('/student/class?view=studentData');
    } else if (isVideo(chapter, resources)) {
      redirectToAssignmentVideo(chapter,assignmentId);
    } else if (isExamHidden(chapter)) {
      setReviewDialog({
        open: true,
        message: 'Your teacher has hidden this exam and you are no longer able to take it.'
      });
      return;
    } else if (chapter == "33" || chapter == "41" || chapter == "43" || chapter == "49") {
      const BALCON_PAGES = get(find(bookUnits, ["bookId", chapter]), "pages", [])
      const typeId = "";
      const bookitem = find(BALCON_PAGES, k => parseInt(k.start) <= assignmentPage && parseInt(k.finish) >= assignmentPage)
      if (!bookitem) {
        setReviewDialog({
          open: true,
          message: 'We could not find the requested page for this book. Please check the assignment details.'
        });
        return;
      }
      if (chapter == '33') {
        let url = `/balconCulturalBook?id=${bookitem?.id}&page=${assignmentPage}&activity=${typeId.includes('activity') ? assignmentId : null}&quiz=${typeId.includes('quiz') ? assignmentId : null}`
        navigate(url);
        openEngageModal();
      } else if (chapter == '41') {
        let url = `/informateBook?id=${bookitem?.id}&page=${assignmentPage}&activity=${typeId.includes('activity') ? assignmentId : null}&quiz=${typeId.includes('quiz') ? assignmentId : null}`
        navigate(url);
        openEngageModal();
      } else if (chapter == '43') {
        let url = `/ComunidadBook?id=${bookitem?.id}&page=${assignmentPage}&activity=${typeId.includes('activity') ? assignmentId : null}&quiz=${typeId.includes('quiz') ? assignmentId : null}`
        navigate(url);
        openEngageModal();
      } else if (chapter == '49') {
        let url = `/ConectandomeBook?id=${bookitem?.id}&page=${assignmentPage}&activity=${typeId.includes('activity') ? assignmentId : null}&quiz=${typeId.includes('quiz') ? assignmentId : null}`
        navigate(url);
        openEngageModal();
      }
    } else {
      navigate(`/ebook?chapter=${chapter}&page=${assignmentPage}&activity=${data?.data.typeId === 'activity' ? assignmentId : null}&quiz=${data?.data.typeId === 'quiz' ? assignmentId : null}`);
      openEngageModal();
    }
  }

  const createNotification = async (data) => {
    if (data?.id && currentUser?.id) {
      const userId = currentUser.id;
      setNotificationsData(prev => {
        const updated = prev.map(notif => {
          if (notif.id === data.id || notif.firebaseDocId === data.firebaseDocId) {
            const existingUserSeen = notif.userSeen || [];
            if (!existingUserSeen.includes(userId)) {
              return {
                ...notif,
                userSeen: [...existingUserSeen, userId]
              };
            }
          }
          return notif;
        });
        return updated;
      });
      await updateCollectionNotification(data?.id, userId)
    }
  }

  const getClassAssignment = async () => {
    dispatch(handleListClassActivities(currentClass.id));
    dispatch(handleListClassQuizzes(currentClass.id));
    dispatch(handleListClassSubmissions(get(currentClass, "id")))
  }

  const onStudentEndNotification = (data, findData) => {
    if (data.type == 'delete_activity' || data?.type == 'delete_quiz') {
      return;
    } else {
      const now = new Date();
      if (new Date(data?.data?.scheduleAt) > now) {
        setReviewDialog({ open: true, message: 'This activity is scheduled to start soon. Please wait until it begins.' });
      } else {
        onNotificationClick(data);
        setIsnotification(false);
      }
    }
  }

  const handleClose = () => {
    setReviewDialog({ open: false, message: '' });
  };

  const onReadAllNotification = async () => {
    try {
      setMarkAllDoneNotificationLoading(true);
      if (allNotificationsData.length > 0) {
        const regularNotifications = filter(notificationsData, obj => obj.type !== 'share_notification');
        const shareNotifications = [...shareNotificationsData];
        
        if (regularNotifications.length > 0) {
          await markAllAsRead(
            get(currentUser, 'id', ''), 
            get(currentClass, 'id', ''),
            (progress) => {
              console.log(`Processing batch ${progress.current}/${progress.total} - ${progress.processed}/${progress.totalDocs} notifications`);
            }
          );
        }
        
        if (shareNotifications.length > 0 && currentUser?.id) {
          const shareNotificationIds = map(shareNotifications, notif => notif.id);
          await updateShareNotificationsBatch(shareNotificationIds, currentUser.id);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setMarkAllDoneNotificationLoading(false);
    }
  };

  const onRoleCheck = async (data) => {
    setloadingQuestions(true);
  try {
    if (data?.type === 'share_notification') {
      if (data?.id && currentUser?.id) {
        await updateShareNotification(data.id, currentUser.id);
      }
      const shareData = data.shareNotificationData || data;
      const assignmentType = shareData?.data?.assignmentType || shareData?.assignmentType;
      
      let notificationChapter = data?.data?.chapter || 
                                shareData?.data?.chapter || 
                                shareData?.chapter || 
                                shareData?.bookId || 
                                data?.data?.bookId ||
                                data?.shareNotificationData?.chapter ||
                                data?.shareNotificationData?.bookId;
      
      let notificationPage = data?.data?.page || 
                            data?.data?.pageId ||
                            shareData?.data?.page || 
                            shareData?.data?.pageId ||
                            shareData?.page || 
                            shareData?.pageId ||
                            data?.shareNotificationData?.page ||
                            data?.shareNotificationData?.pageId;
      
      if (!notificationPage || !notificationChapter) {
        const url = shareData?.url || data?.data?.url || data?.url;
        if (url) {
          const urlMatch = url.match(/[?&]chapter=(\d+)/);
          const pageMatch = url.match(/[?&]page=(\d+)/);
          if (!notificationChapter && urlMatch) {
            notificationChapter = urlMatch[1];
          }
          if (!notificationPage && pageMatch) {
            notificationPage = pageMatch[1];
          }
        }
      }
      
      if (assignmentType === 'story' || shareData?.type === 'soy_historias') {
        const classId = shareData?.data?.class_id || shareData?.class_id || get(currentClass, 'id', '');
        
        const isEbookPath = ['/ebook', '/balconCulturalBook', '/stories', '/video'].some((path) =>
          location.pathname.includes(path)
        );
        
        if (isEbookPath) {
          await dispatch(handleListStoryAiConfig({
            chapter: notificationChapter,
            user_id: get(currentUser, "id", ""),
            class_id: classId
          }, currentUser?.role === 'student'));
        }
        
        const url = shareData?.url || data?.data?.url;
        
        dispatch(updateUI({
          soyHistoriasView: {
            type: 'soyHistoriasView',
            data: shareData?.shared_data,
            chapter: notificationChapter,
            page: notificationPage,
            open: true,
            isNotification: true
          }
        }));
        
        if (url) {
          setTimeout(() => {
            navigate(url);
          }, 0);
        }
        return;
      }
      
      if (data?.data?.assignmentType === 'worksheet' && currentUser?.id) {
        await dispatch(handleListClassSubmissions(get(currentClass, "id")))
      }
      
      const url = shareData?.url || data?.data?.url;
      if (url) {
        navigate(url);
      } else {
        await onNotificationClick(data);
      }
      return;
    }

    const notificationData = {
      ...data,
      seen: false
    }
    // Try to find the assignment
     let assignmentId = get(data, "data.id", '');
     let allAssignment = [...classActivities, ...classQuizzes, ...class_game_activity];
     let findData = find(allAssignment, obj => obj?.session_id ? get(obj, 'session_id', '') == assignmentId : get(obj, 'data.id', '') == assignmentId ? get(obj, 'data.id', '') == assignmentId : get(obj, 'activityId', '') == assignmentId);

     // If not found, fetch and try again
     if (!findData) {
       await dispatch(handleListClassSubmissions(get(currentClass, "id")))
       allAssignment = [...classActivities, ...classQuizzes, ...class_game_activity];
       findData = find(allAssignment, obj => obj?.session_id ? get(obj, 'session_id', '') == assignmentId : get(obj, 'data.id', '') == assignmentId);
     }
    if (get(currentUser, "role") === "teacher") {
      const shareData = data.shareNotificationData || data;
      const notificationChapter = shareData?.chapter || shareData?.bookId || data?.data?.chapter;
      const notificationPage = shareData?.page || shareData?.pageId || data?.data?.page;
      const params = new URLSearchParams(window.location.search);
      const currentChapter = params.get("chapter") || "";
      const currentPage = params.get("page") || "";
      const isSamePage = Number(currentChapter) === Number(notificationChapter) && 
                        Number(currentPage) === Number(notificationPage);
      
      if (data?.id && currentUser?.id) {
        setShareNotificationsData(prev => prev.map(notif => {
            if (notif.id === data.id) {
                return {
                    ...notif,
                    userSeen: [...(notif.userSeen || []), currentUser.id]
                };
            }
            return notif;
        }));
        await updateShareNotification(data.id, currentUser.id);
      }
    
      if (data?.data?.assignmentType === 'worksheet' && currentUser?.id) {
          if (isSamePage) {
              await dispatch(handleListWorkSheet(notificationChapter, currentUser?.role, currentUser?.id, 100, 0, true, null, currentClass?.id));
          }
          // onGetAssignment();
      }
      
      const url = shareData?.url || data?.data?.url;
      if (url) {
          if (isSamePage && data?.data?.assignmentType === 'worksheet') {
              window.location.reload();
          } else {
              navigate(url);
          }
      } else {
          await onNotificationClick(data);
      }
      
      setIsnotification(false);
      // setIsnotificationMob(false);
      return;
    } else {
      const notificationData = {
        ...data,
        seen: false
      }
      // Try to find the assignment
       let assignmentId = get(data, "data.id", '');
       let allAssignment = [...classActivities, ...classQuizzes, ...class_game_activity];
       let findData = find(allAssignment, obj => obj?.session_id ? get(obj, 'session_id', '') == assignmentId : get(obj, 'data.id', '') == assignmentId ? get(obj, 'data.id', '') == assignmentId : get(obj, 'activityId', '') == assignmentId);
  
       // If not found, fetch and try again
       if (!findData) {
         await dispatch(handleListClassSubmissions(get(currentClass, "id")))
         allAssignment = [...classActivities, ...classQuizzes, ...class_game_activity];
         findData = find(allAssignment, obj => obj?.session_id ? get(obj, 'session_id', '') == assignmentId : get(obj, 'data.id', '') == assignmentId);
       }
      if (get(currentUser, "role") === "teacher") {
        await Promise.allSettled([
          createNotification(notificationData, data),
          getClassAssignment()
        ]);
        await dispatch(handleListClassActivities(currentClass.id));
        await dispatch(handleListClassSubmissions(get(currentClass, "id")))
        setReviewData(findData);
        setSelectedNotification(data);
        toggleAssignmentDrawer(true);
        setIsnotification(false);
      } else {
        if (data.type === "play_game_notification") {
          setIsnotification(false);
          createNotification(notificationData, data);
          dispatch(handleGamePopupNotify(data.data))
        } else {
          const assignmentData = findData?.data || data?.data;
          if (assignmentData?.config_assignment?.isFrom === 'engagement') {
            const engageData = findEngageData(assignmentData);
            if (engageData && engageData?.imageData?.length > 0) {
              updatePopUpAtOnce(false);
              dispatch(updateUI({ openEngageModalTeacher: { open: true, data: engageData?.imageData } }));
            }
          }
          createNotification(notificationData, data);
          onStudentEndNotification(data, findData);
        }
      }
      }
    } catch (error) {
      console.error("Error in onRoleCheck:", error);
    } finally {
      setloadingQuestions(false);
    }
  }

  const SingleNotificationSection = ({ item }) => {
    const inputDate = get(item, "modified", "") || get(item, "shared_time", "");
    // const seenStatus = get(item, "seen", '');
    const userSeen = get(item, "userSeen", '');
    const seenStatus = userSeen ? !userSeen.includes(currentUser?.id) : get(item, "seen", '');
    const assignmentId = get(item, "data.id", '')
    const scheduleAt = get(item, "data.scheduleAt", '')
    const findData = find(allAssignment, obj => obj?.session_id ? get(obj, 'session_id', '') == assignmentId : get(obj, 'data.id', '') == assignmentId)
    // if(!findData && currentUser?.role === "student"){
    //   return  null;
    // }
    
    let result = "Invalid Date";
    if (inputDate) {
      const date = new Date(inputDate);
      if (!isNaN(date.getTime())) {
        const formattedDate = date.toLocaleDateString("en-US", {
          weekday: "short",
          year: "numeric",
          month: "long",
          day: "numeric",
        });
        const formattedTime = date.toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "numeric",
          hour12: true,
        });
        // Combine the formatted date and time
         result = `${formattedDate} at ${formattedTime}`;
      }
    }
    return (
      <Badge.Ribbon text={seenStatus ? 'New' : 'Done'} color={seenStatus ? 'red' : '#03989e'}>
      <Card.Grid style={seenStatus ? gridStyleSeen : gridStyle} onClick={() => {
        onRoleCheck(item, findData)
      }}> 
        <Row>
          <Col xs={24} lg={24}>
            <NotificationsMainSection>
              <Image
                src={modalSrc(item, findData)}
                alt={""}
              />
              <NotificationSection>
                  <TextTitle className="breakTheSentance widthLessText">{item.displayName}</TextTitle>
                  <TextDateTitle>
                    {item.message}
                    {scheduleAt && new Date(scheduleAt) > new Date() && (
                      <>
                        <br />
                        <span style={{ color: '#1890ff' }}>
                          Scheduled to start at: {new Date(scheduleAt).toLocaleString('en-US', {
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric',
                            hour: 'numeric',
                            minute: 'numeric',
                            hour12: true
                          })}
                        </span>
                      </>
                    )}
                  </TextDateTitle>
                  <span style={{ width: '6px' }}></span>
                <TextDate>{result}</TextDate>
              </NotificationSection>
            </NotificationsMainSection>
          </Col>
        </Row>
      </Card.Grid>
      </Badge.Ribbon>
    );
  };
  return (
    <SentryWrap>
    <Container>
      <SpinLoader dataloader={loadingQuestions} />
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={openReviewDialog.open}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity='info'>
          <strong>ALERT:</strong> {openReviewDialog.message}
        </Alert>
      </Snackbar>
      <BackButton onClick={() => navigate(-1)}>&larr; Back</BackButton>
      {assignmentDrawer ? <AssignmentReviewByNotify assignment={reviewData} assignmentDrawer={assignmentDrawer} selectedNotification={selectedNotification} oncloseDrawer={() => {
        toggleAssignmentDrawer(false)
      }} /> : null}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
        <NotificationTitle>Notifications</NotificationTitle>
        {allNotificationsData.length > 0 && (
          <ReadAllBtn onClick={() => {
            onReadAllNotification();
          }}>
            <TextReadAll>{markAllDoneNotificationLoading ? <Loading size={16} /> : 'Mark All As Viewed'}</TextReadAll>
          </ReadAllBtn>
        )}
      </div>
      {allNotificationsData.length === 0 ? (
        <div className="notifiPlaceholder">
          <Suspense fallback={null}>
            <Lottie animationData={NOTIFICATIONICONS.poster} />
          </Suspense>
        </div>
      ) : (
        <>
          {map(paginatedNotifications, (item) => (
            <SingleNotificationSection item={item} key={item.id} />
          ))}
          {allNotificationsData.length > pageSize && (
            <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'center' }}>
              <Pagination
                current={currentPage}
                total={allNotificationsData.length}
                pageSize={pageSize}
                onChange={(page) => setCurrentPage(page)}
                showSizeChanger={false}
              />
            </div>
          )}
        </>
      )}
    </Container>
    </SentryWrap>
  );
};

export default Notification;
